import React from 'react';

const PDFFilePreview = ({ fileUrl, fileName }) => {
  // Create a direct URL with the token as a query parameter
  const getAuthenticatedUrl = () => {
    const token = localStorage.getItem('token');
    if (!token) return fileUrl;
    
    // Check if URL already has parameters
    const separator = fileUrl.includes('?') ? '&' : '?';
    return `${fileUrl}${separator}token=${token}`;
  };

  // Open in a new window with token
  const handleFileOpen = (e) => {
    e.preventDefault();
    try {
      const authenticatedUrl = getAuthenticatedUrl();
      window.open(authenticatedUrl, '_blank');
    } catch (error) {
      console.error('Error opening file:', error);
      alert('Failed to open file. Please try again.');
    }
  };

  return (
    <div className="pdf-preview">
      <a 
        href="#"
        onClick={handleFileOpen}
        className="flex items-center gap-2 py-2 px-3 bg-gray-50 dark:bg-[#3d3d3d] rounded-xl border border-gray-200 dark:border-[#444444] hover:bg-gray-100 dark:hover:bg-[#333333] transition-colors cursor-pointer"
      >
        <div className="text-gray-700 dark:text-gray-300 flex-shrink-0">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.33337 1.33334H4.00004C3.64642 1.33334 3.30728 1.47382 3.05723 1.72387C2.80718 1.97392 2.66671 2.31305 2.66671 2.66668V13.3333C2.66671 13.687 2.80718 14.0261 3.05723 14.2762C3.30728 14.5262 3.64642 14.6667 4.00004 14.6667H12C12.3537 14.6667 12.6928 14.5262 12.9428 14.2762C13.1929 14.0261 13.3334 13.687 13.3334 13.3333V5.33334L9.33337 1.33334Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.33337 1.33334V5.33334H13.3334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="text-sm text-gray-700 dark:text-gray-300 truncate flex-1 font-medium">
          {fileName || 'PDF Document'}
        </div>
      </a>
    </div>
  );
};

export default PDFFilePreview; 